import { useEffect, useContext } from "react";
import { LocalStoreContext } from "../store/LocalStore";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { RefContext } from "../store/RefContext";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  border: "none",
  padding: 0,
};

const headerStyle = {
  fontSize: 12,
  fontWeight: 600,
  width: `${100 / 15}%`,
  border: "none",
  padding: 0,
  lineHeight: "100%",
};

const rowStyle = {
  color: "#919191",
  fontSize: 12,
  fontWeight: 400,
  textAlign: "right",
  border: "none",
  padding: 0,
};

const borderStyleRight = {
  borderRight: "1px solid grey",
  paddingRight: 3,
};
const borderStyleLeftRight = {
  borderRight: "1px solid grey",
  borderLeft: "1px solid grey",
};

const clean = (val) => {
  return +val.replace("%", "");
};

export const BreakageAndReturnTableView = () => {
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);
  const { filter, breakageandreturnFiltered, breakageandreturn } = lstore;

  useEffect(() => {
    if (breakageandreturn && breakageandreturn.rawdata.length > 0) {
      const fdata = breakageandreturn.rawdata.filter((row) => {
        return (
          filter["ModelDate"].includes(row["ModelDate"]) &&
          filter["Ticker"].includes(row["Ticker"]) &&
          filter["Horizon"].includes(row["Horizon"]) &&
          filter[" Pctile "].includes(row[" Pctile "])
        );
      });

      const sigma = {};
      const vector = {};
      const avgsigma = {};
      const avgvector = {};
      fdata.forEach((item) => {
        if (item.RiskModel === "Vector") {
          if (item.ModelDate in vector) {
            vector[item.ModelDate] = {
              Counter: vector[item.ModelDate].Counter + 1,
              FwdPxRet: vector[item.ModelDate].FwdPxRet + clean(item.FwdPxRet),
              VaR: vector[item.ModelDate].VaR + clean(item.VaR),
              VaRBreak: vector[item.ModelDate].VaRBreak + clean(item.VaRBreak),
              ROVBC: vector[item.ModelDate].ROVBC + clean(item.ROVBC),
              OaR: vector[item.ModelDate].OaR + clean(item.OaR),
              OaRBreak: vector[item.ModelDate].OaRBreak + clean(item.OaRBreak),
              ROOBC: vector[item.ModelDate].ROOBC + clean(item.ROOBC),
            };
            vector["Grand Total"] = {
              Counter: vector["Grand Total"].Counter + 1,
              FwdPxRet: vector["Grand Total"].FwdPxRet + clean(item.FwdPxRet),
              VaR: vector["Grand Total"].VaR + clean(item.VaR),
              VaRBreak: vector["Grand Total"].VaRBreak + clean(item.VaRBreak),
              ROVBC: vector["Grand Total"].ROVBC + clean(item.ROVBC),
              OaR: vector["Grand Total"].OaR + clean(item.OaR),
              OaRBreak: vector["Grand Total"].OaRBreak + clean(item.OaRBreak),
              ROOBC: vector["Grand Total"].ROOBC + clean(item.ROOBC),
            };
          } else {
            if ("Grand Total" in vector) {
              vector["Grand Total"] = {
                Counter: vector["Grand Total"].Counter + 1,
                FwdPxRet: vector["Grand Total"].FwdPxRet + clean(item.FwdPxRet),
                VaR: vector["Grand Total"].VaR + clean(item.VaR),
                VaRBreak: vector["Grand Total"].VaRBreak + clean(item.VaRBreak),
                ROVBC: vector["Grand Total"].ROVBC + clean(item.ROVBC),
                OaR: vector["Grand Total"].OaR + clean(item.OaR),
                OaRBreak: vector["Grand Total"].OaRBreak + clean(item.OaRBreak),
                ROOBC: vector["Grand Total"].ROOBC + clean(item.ROOBC),
              };
            } else {
              vector["Grand Total"] = {
                Counter: 1,
                FwdPxRet: clean(item.FwdPxRet),
                VaR: clean(item.VaR),
                VaRBreak: clean(item.VaRBreak),
                ROVBC: clean(item.ROVBC),
                OaR: clean(item.OaR),
                OaRBreak: clean(item.OaRBreak),
                ROOBC: clean(item.ROOBC),
              };
            }
            vector[item.ModelDate] = {
              Counter: 1,
              FwdPxRet: clean(item.FwdPxRet),
              VaR: clean(item.VaR),
              VaRBreak: clean(item.VaRBreak),
              ROVBC: clean(item.ROVBC),
              OaR: clean(item.OaR),
              OaRBreak: clean(item.OaRBreak),
              ROOBC: clean(item.ROOBC),
            };
          }
        } else {
          if (item.ModelDate in sigma) {
            sigma[item.ModelDate] = {
              Counter: sigma[item.ModelDate].Counter + 1,
              FwdPxRet: sigma[item.ModelDate].FwdPxRet + clean(item.FwdPxRet),
              VaR: sigma[item.ModelDate].VaR + clean(item.VaR),
              VaRBreak: sigma[item.ModelDate].VaRBreak + clean(item.VaRBreak),
              ROVBC: sigma[item.ModelDate].ROVBC + clean(item.ROVBC),
              OaR: sigma[item.ModelDate].OaR + clean(item.OaR),
              OaRBreak: sigma[item.ModelDate].OaRBreak + clean(item.OaRBreak),
              ROOBC: sigma[item.ModelDate].ROOBC + clean(item.ROOBC),
            };
            sigma["Grand Total"] = {
              Counter: sigma["Grand Total"].Counter + 1,
              FwdPxRet: sigma["Grand Total"].FwdPxRet + clean(item.FwdPxRet),
              VaR: sigma["Grand Total"].VaR + clean(item.VaR),
              VaRBreak: sigma["Grand Total"].VaRBreak + clean(item.VaRBreak),
              ROVBC: sigma["Grand Total"].ROVBC + clean(item.ROVBC),
              OaR: sigma["Grand Total"].OaR + clean(item.OaR),
              OaRBreak: sigma["Grand Total"].OaRBreak + clean(item.OaRBreak),
              ROOBC: sigma["Grand Total"].ROOBC + clean(item.ROOBC),
            };
          } else {
            if ("Grand Total" in sigma) {
              sigma["Grand Total"] = {
                Counter: sigma["Grand Total"].Counter + 1,
                FwdPxRet: sigma["Grand Total"].FwdPxRet + clean(item.FwdPxRet),
                VaR: sigma["Grand Total"].VaR + clean(item.VaR),
                VaRBreak: sigma["Grand Total"].VaRBreak + clean(item.VaRBreak),
                ROVBC: sigma["Grand Total"].ROVBC + clean(item.ROVBC),
                OaR: sigma["Grand Total"].OaR + clean(item.OaR),
                OaRBreak: sigma["Grand Total"].OaRBreak + clean(item.OaRBreak),
                ROOBC: sigma["Grand Total"].ROOBC + clean(item.ROOBC),
              };
            } else {
              sigma["Grand Total"] = {
                Counter: 1,
                FwdPxRet: clean(item.FwdPxRet),
                VaR: clean(item.VaR),
                VaRBreak: clean(item.VaRBreak),
                ROVBC: clean(item.ROVBC),
                OaR: clean(item.OaR),
                OaRBreak: clean(item.OaRBreak),
                ROOBC: clean(item.ROOBC),
              };
            }
            sigma[item.ModelDate] = {
              Counter: 1,
              FwdPxRet: clean(item.FwdPxRet),
              VaR: clean(item.VaR),
              VaRBreak: clean(item.VaRBreak),
              ROVBC: clean(item.ROVBC),
              OaR: clean(item.OaR),
              OaRBreak: clean(item.OaRBreak),
              ROOBC: clean(item.ROOBC),
            };
          }
        }
      });

      //calculate averages
      Object.entries(vector).forEach((item) => {
        avgvector[item[0]] = {
          FwdPxRet: (item[1].FwdPxRet / item[1].Counter).toFixed(2) + "%",
          VaR: (item[1].VaR / item[1].Counter).toFixed(2) + "%",
          VaRBreak: (item[1].VaRBreak / item[1].Counter).toFixed(2) + "%",
          ROVBC: (item[1].ROVBC / item[1].Counter).toFixed(2) + "%",
          OaR: (item[1].OaR / item[1].Counter).toFixed(2) + "%",
          OaRBreak: (item[1].OaRBreak / item[1].Counter).toFixed(2) + "%",
          ROOBC: (item[1].ROOBC / item[1].Counter).toFixed(2) + "%",
        };
      });
      Object.entries(sigma).forEach((item) => {
        avgsigma[item[0]] = {
          FwdPxRet: (item[1].FwdPxRet / item[1].Counter).toFixed(2) + "%",
          VaR: (item[1].VaR / item[1].Counter).toFixed(2) + "%",
          VaRBreak: (item[1].VaRBreak / item[1].Counter).toFixed(2) + "%",
          ROVBC: (item[1].ROVBC / item[1].Counter).toFixed(2) + "%",
          OaR: (item[1].OaR / item[1].Counter).toFixed(2) + "%",
          OaRBreak: (item[1].OaRBreak / item[1].Counter).toFixed(2) + "%",
          ROOBC: (item[1].ROOBC / item[1].Counter).toFixed(2) + "%",
        };
      });

      //combine keys
      let distinct = Array.from(
        new Set(Object.keys(avgsigma).concat(Object.keys(avgvector)))
      );

      const combined = {};
      distinct.forEach((item) => {
        combined[item] = { sigma: avgsigma[item], vector: avgvector[item] };
      });

      ldispatch({
        type: lactionTypes.SET_BREAKAGEANDRETURN_FILTERED,
        payload: combined,
      });
    }
  }, [breakageandreturn, ldispatch, filter]);

  return breakageandreturnFiltered ? (
    <div
      style={{
        height: refs.componentSize.current["BreakageAndReturnTableView"].height,
        width:
          refs.componentSize.current["BreakageAndReturnTableView"].width - 20,
        margin: 0,
      }}
    >
      <table style={tableStyle} className="stripes">
        <thead>
          <tr style={{ ...rowStyle, textAlign: "center" }}>
            <td></td>
            <td style={borderStyleLeftRight} colSpan={14}>
              Risk Model
            </td>
          </tr>
          <tr style={{ ...rowStyle, textAlign: "center" }}>
            <td></td>
            <td style={borderStyleLeftRight} colSpan={7}>
              Sigma
            </td>
            <td style={borderStyleLeftRight} colSpan={7}>
              Vector
            </td>
          </tr>
          <tr style={rowStyle}>
            <td
              style={{ ...borderStyleRight, ...headerStyle, textAlign: "left" }}
            >
              Model Date
            </td>
            <td style={headerStyle}>Avg Fwd Px Ret</td>
            <td style={headerStyle}>Avg VaR</td>
            <td style={headerStyle}>Avg VaR Break</td>
            <td style={headerStyle}>Avg Rovbc</td>
            <td style={headerStyle}>Avg OaR</td>
            <td style={headerStyle}>Avg OaR Break</td>
            <td style={{ ...borderStyleRight, ...headerStyle }}>Avg Roobc</td>
            <td style={headerStyle}>Avg Fwd Px Ret</td>
            <td style={headerStyle}>Avg VaR</td>
            <td style={headerStyle}>Avg VaR Break</td>
            <td style={headerStyle}>Avg Rovbc</td>
            <td style={headerStyle}>Avg OaR</td>
            <td style={headerStyle}>Avg OaR Break</td>
            <td style={{ ...borderStyleRight, ...headerStyle }}>Avg Roobc</td>
          </tr>
        </thead>
        <tbody>
          {Object.entries(breakageandreturnFiltered).map((item, i) => {
            return (
              <tr key={i} style={rowStyle}>
                <td style={{ ...borderStyleRight, textAlign: "left" }}>
                  {item[0]}
                </td>
                <td>{item[1].sigma.FwdPxRet}</td>
                <td>{item[1].sigma.VaR}</td>
                <td>{item[1].sigma.VaRBreak}</td>
                <td>{item[1].sigma.ROVBC}</td>
                <td>{item[1].sigma.OaR}</td>
                <td>{item[1].sigma.OaRBreak}</td>
                <td style={borderStyleRight}>{item[1].sigma.ROOBC}</td>

                <td>{item[1].vector.FwdPxRet}</td>
                <td>{item[1].vector.VaR}</td>
                <td>{item[1].vector.VaRBreak}</td>
                <td>{item[1].vector.ROVBC}</td>
                <td>{item[1].vector.OaR}</td>
                <td>{item[1].vector.OaRBreak}</td>
                <td style={borderStyleRight}>{item[1].vector.ROOBC}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  ) : null;
};
